export const STATUS_CONFIG: Record<string, { label: string; color: string }> = {
  P: { label: 'Programada', color: '#3b82f6' },
  A: { label: 'Em Trânsito', color: '#fbbf24' },
  F: { label: 'Finalizada', color: '#64748b' },
  D: { label: 'Descarregada', color: '#10b981' },
};

export const formatNumber = (num: number, decimals = 0, suffix = '') => {
  return (
    new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(num) + (suffix ? ` ${suffix}` : '')
  );
};

export const formatName = (fullName: string) => {
  if (!fullName) return '';
  const parts = String(fullName).trim().split(/\s+/);
  return parts.slice(0, 2).join(' ');
};

export const formatCompactNumber = (num: number) => {
  return new Intl.NumberFormat('pt-BR', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(num);
};
